CustomTC.define('modules/constants',[],function() {
    return {
        // sdk readyreadyready
        EVENT_SDK_READY: 'TouchCast_sdkReady',
        // interactionLayer Initialized
        EVENT_INTERACTIVELAYER_INITIALIZED: 'TouchCast_interactiveLayerInitialized',
        // partially ready
        EVENT_PARTIALLY_READY: 'TouchCast_videosPartiallyReady',
        // fully ready
        EVENT_FULLY_READY: 'TouchCast_videosFullyReady',
        // entered PIP Mode
        EVENT_ENTERED_PIPMODE: 'TouchCast_enteredPIPMode',
        // vapp Clicked
        EVENT_VAPP_CLICKED: 'TouchCast_vAppClicked',
        // exit PIP Mode
        EVENT_EXIT_PIPMODE: 'TouchCast_exitPIPMode',
        // entered On Screen vApp
        EVENT_ONSCREEN_VAPP: 'TouchCast_onScreenVapp',
        // time update on player
        EVENT_TIME_UPDATE: 'TouchCast_timeUpdate',
        // video is started
        EVENT_VIDEO_START: 'TouchCast_videoStart',
        // video is played
        EVENT_VIDEO_PLAY: 'TouchCast_videoPlay',
        // video is paused
        EVENT_VIDEO_PAUSE: 'TouchCast_videoPause',
        // video is ended
        EVENT_VIDEO_END: 'TouchCast_videoEnd',
        // we are going into inside TouchCast
        EVENT_INSIDE_TOUCHCAST: 'TouchCast_insideTC',
        // pause video in custom
        EVENT_PAUSE_VIDEO_FROM_INTERACTIVE_LAYER: 'TouchCast_pauseVideoFromInteractiveLayer',
        // resume video in custom
        EVENT_RESUME_VIDEO_FROM_INTERACTIVE_LAYER: 'TouchCast_resumeVideoFromInteractiveLayer',
        // seek video in custom
        EVENT_SEEK_VIDEO_FROM_INTERACTIVE_LAYER: 'TouchCast_seekVideoFromInteractiveLayer',
        //css class for active
        CSS_TOUCHCAST_ACTIVE: 'active',
        //css class for hover
        CSS_TOUCHCAST_HOVER: 'hover',
        //css class for selected
        CSS_TOUCHCAST_SELECTED: 'selected',
        //css class for current
        CSS_TOUCHCAST_CURRENT: 'current',
        //css class for open
        CSS_TOUCHCAST_OPEN: 'open',
        //css class for hide
        CSS_TOUCHCAST_HIDE: 'hide',
        //css class for disable
        CSS_TOUCHCAST_DISABLE: 'tcDisable',
        //css class for pip mode
        CSS_TOUCHCAST_PIP_MODE: 'pip_mode',
        //css class for blank iframe
        CSS_TOUCHCAST_BLANK_IFRAME: 'blank_iframe',
        //css class for tc login link
        CSS_TOUCHCAST_LOGIN_LINK: 'login-signup',
        //css class for tc close btn link
        CSS_TOUCHCAST_CLOSE_BUTTON: 'close-btn',
        //css class for tool tip
        CSS_TOUCHCAST_TOOL_TIP: 'tool-tip',
        //css class for fit screen
        CSS_TOUCHCAST_FIT_SCREEN: 'tcFitScreen',
        //css class for abs fit screen
        CSS_TOUCHCAST_ABS_FIT_SCREEN: 'tcFitScreenAbs',
        //css class for main container
        CSS_TOUCHCAST_MAIN_CONTAINER: 'tcMainContainer',
        //css class for main wrapper
        CSS_TOUCHCAST_MAIN_WRAPPER: 'tcMainWrapper',
        //css class for flash player
        CSS_TOUCHCAST_FLASH_PLAYER: 'flashPlayer',
        //css class for player container
        CSS_TOUCHCAST_PLAYER_CONTAINER: 'tcPlayerContainer',
        //css class for player element
        CSS_TOUCHCAST_PLAYER_ELEMENT: 'tcPlayer',
        //css id for video element
        CSS_TOUCHCAST_VIDEO_ELEMENT: 'videoplayer',
        //css id for flash video element
        CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT: 'videoplayer',
        //css name for flash video element
        CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT_NAME: 'video_flashplayer',
        //css id for iphone canvas
        CSS_TOUCHCAST_IPHONE_CANVAS: 'iphone-canvas',
        //css class for player header
        CSS_TOUCHCAST_PLAYER_HEADER: 'tcPlayerHeader',
        //css class for player header hover
        CSS_TOUCHCAST_PLAYER_HEADER_HOVER: 'tcPlayerHeaderHover',
        //css class for flash overlay
        CSS_TOUCHCAST_FLASH_OVERLAY: 'flash_overlay',
        //css id for flash video container
        CSS_TOUCHCAST_FLASH_VIDEO_CONTAINER: 'flash_video_container',
        //css class for no flash plugin
        CSS_TOUCHCAST_NO_FLASH_PLUGIN: 'noFlashPlugin',
        //css class for no flash
        CSS_TOUCHCAST_NO_FLASH: 'no_flash',
        //css class for no flash hide
        CSS_TOUCHCAST_NO_FLASH_HIDE: 'hideNoFlash',
        //css class for hover active
        CSS_TOUCHCAST_HOVER_ACTIVE: 'tcHoverActive',
        //css class for stop propagation
        CSS_TOUCHCAST_STOP_PROPAGATION: 'tcStopPropagation',
        //css class for align middle x & y
        CSS_TOUCHCAST_ALIGN_MIDDLE_XY: 'alignMiddleXY',
        //css class for fullscreen button
        CSS_TOUCHCAST_FULLSCREEN_BUTTON: 'tcBtnFullscreen',
        //css class for volume container
        CSS_TOUCHCAST_VOLUME_CONTAINER: 'volume-container',
        //css class for player tools
        CSS_TOUCHCAST_PLAYER_TOOLS: 'tcPlayerTools',
        //css class for progress panel
        CSS_TOUCHCAST_PROGRESS_PANEL: 'tcProgressPanel',
        //css class for progress container
        CSS_TOUCHCAST_PROGRESS_CONTAINER: 'tcProgressContainer',
        //css class for no volume fullscreen
        CSS_TOUCHCAST_NO_VOLUME_FULLSCREEN: 'noVolumeFullScreen',
        //css class for dropdown toggle
        CSS_TOUCHCAST_DROPDOWN_TOGGLE: 'dropdown-toggle',
        // css id for player loading container
        CSS_TOUCHCAST_LOADING_WRAPPER: 'tcLoad',
        //css class for player loading container
        CSS_TOUCHCAST_LOADING_CONTAINER: 'tcLoadingContainer',
        //css class for player loading
        CSS_TOUCHCAST_PLAYER_LOADING: 'playerLoading',
        //css class for comments loading container
        CSS_TOUCHCAST_COMMENTS_LOADING_CONTAINER: 'commentLoader',
        //css class for loading spinner
        CSS_TOUCHCAST_LOADING_SPINNER: 'spinner',
        //css class for player controls
        CSS_TOUCHCAST_CONTROLS: 'tcControls',
        //css class for video poster
        CSS_TOUCHCAST_POSTER: 'video-poster',
        //css class for main play container
        CSS_TOUCHCAST_MAIN_PLAY_CONTAINER: 'tcMainPlayContainer',
        //css class for main play button
        CSS_TOUCHCAST_MAIN_PLAY_BUTTON: 'tcMainPlay',
        //css id for main play button
        CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID: 'playPause',
        //css class for play pause button
        CSS_TOUCHCAST_PLAY_PAUSE_BUTTON: 'playpause',
        //css class for poster image
        CSS_TOUCHCAST_POSTER_IMAGE: 'tcVideoPosterImg',
        //css class for progress track
        CSS_TOUCHCAST_PROGRESS_TRACK: 'track',
        //css class for time code
        CSS_TOUCHCAST_TIMECODE: 'tcVideoTime',
        //css class for total duration label
        CSS_TOUCHCAST_DURATION_LABEL: 'duration',
        //css class for current time label
        CSS_TOUCHCAST_CURRENT_TIME_LABEL: 'curtime',
        //css class for progress
        CSS_TOUCHCAST_PROGRESS: 'progress',
        //css class for buffer progress
        CSS_TOUCHCAST_PROGRESS_BUFFER: 'buffered',
        //css class for touchcast browser
        CSS_TOUCHCAST_BROWSER: 'touchcast_browser',
        //css class for video end overlay
        CSS_TOUCHCAST_VIDEO_END_OVERLAY: 'tcVideoEndOverlay',
        //css class for plause button
        CSS_TOUCHCAST_PLAYER_PAUSE_BUTTON: 'tcPauseButton',
        //css class for play button
        CSS_TOUCHCAST_PLAYER_PLAY_BUTTON: 'tcPlayButton',
        //css class for tap or click container
        CSS_TOUCHCAST_TAP_OR_CLICK_CONTAINER: 'tcTapOrClickContainer',
        //css class for control button divider
        CSS_TOUCHCAST_CONTROL_BUTTON_DIVIDER: 'divider',
        //css class for player control info icon
        CSS_TOUCHCAST_CONTROL_BUTTON_INFO: 'tcInfo',
        //css class for player control comment icon
        CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT: 'tcVideoCommentIcon',
        //css class for player control recast icon
        CSS_TOUCHCAST_CONTROL_BUTTON_RECAST: 'tcVideoRecastIcon',
        //css class for player control recasted icon
        CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED: 'tcVideoReCasted',
        //css class for player control share icon
        CSS_TOUCHCAST_CONTROL_BUTTON_SHARE: 'tcShareButton',
        //css id for recast popup button for remove recast from a video
        CSS_TOUCHCAST_CONTROL_BUTTON_REMOVE_RECAST: 'removeReCast',
        //css class for info panel counts wrapper
        CSS_TOUCHCAST_INFO_PANEL_COUNTS_WRAPPER: 'tcVideoViewsSharesReCastsWrapper',
        //css class for venobox frame
        CSS_TOUCHCAST_VENOBOX_FRAME: 'venoframe',
        //css class for share panel
        CSS_TOUCHCAST_SHARE_PANEL: 'tcSharePanel',
        //css class for info panel
        CSS_TOUCHCAST_INFO_PANEL: 'tcInfoBarContainer',
        //css class for panel slide down
        CSS_TOUCHCAST_PANEL_SLIDE_DOWN: 'tcSlideDown',
        //css class for recast control wrapper
        CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER: 'tcNewreCastWrapper',
        //css class for remove recast control wrapper
        CSS_TOUCHCAST_CONTROL_REMOVE_RECAST_CONTAINER: 'removeNewreCast',
        //css class for recast control container
        CSS_TOUCHCAST_CONTROL_RECAST_POPUP_SHOW: 'showNewreCastBox',
        //css class for recast control wrapper bottom arrow
        CSS_TOUCHCAST_CONTROL_RECAST_POPUP_BOTTOM_ARROW: 'showRecastPopupArrow',
        //css id for recast popup button for recasting a video
        CSS_TOUCHCAST_CONTROL_RECAST_POPUP_BUTTON_RECAST: 'reCastThisTC',
        //css id for embeded tc confirmation popup
        CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP: 'tcEmbedConfimationPopup',
        //css id for embeded tc confirmation popup description
        CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_DESCRIPTION: 'tcEmbedDesc',
        //css id for embeded tc confirmation popup description
        CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_TITLE: 'tcEmbedTitle',
        //css id for embeded tc not supported browser list
        CSS_TOUCHCAST_EMBEDED_BROWSER_LIST: 'tcLiveBrowserList',
        //css id for embeded tc confirmation popup YES button
        CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_YES_BUTTON: 'btnEmbedConfirmationYes',
        //css id for embeded tc confirmation popup NO button
        CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_NO_BUTTON: 'btnEmbedConfirmationNo',
        //css id for embeded tc confirmation popup OK button
        CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_OK_BUTTON: 'btnEmbedConfirmationOk',
        //css class for right control buttons container
        CSS_TOUCHCAST_CONTROL_RIGHT_CONTAINER: 'tcRightSideTools',
        //css class for progress bar track guide
        CSS_TOUCHCAST_PROGRESS_TRACK_GUIDE: 'tcTrackGuide',
        //css class for progress bar track code guide
        CSS_TOUCHCAST_PROGRESS_TRACK_CODE_GUIDE: 'tcTimeCodeGuide',
        //css class for volume value label
        CSS_TOUCHCAST_VOLUME_LABEL: 'cur-volume',
        //css class for volume control
        CSS_TOUCHCAST_VOLUME_CONTROL: 'volume-control',
        //css class for volume icon
        CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME: 'volume',
        //css class for mouse active
        CSS_TOUCHCAST_MOUSE_ACTIVE: 'mouse-active',
        //css class for share copy link
        CSS_TOUCHCAST_SHARE_COPY_LINK: 'copyLink',
        //css class for text to copy
        CSS_TOUCHCAST_SHARE_TEXT_TO_COPY: 'txtToCopy',
        //css class for text to animate
        CSS_TOUCHCAST_COPY_TEXT_TO_ANIMATE: 'txtToAnimate',
        //css class for animate
        CSS_TOUCHCAST_ANIMATE: 'animate',
        //css class for share panel close button
        CSS_TOUCHCAST_SHARE_PANEL_CLOSE_BUTTON: 'tcSharePanelButton',
        //css class for share tab section
        CSS_TOUCHCAST_SHARE_TAB_SECTION: 'tcTabSection',
        //css class for share tab menus
        CSS_TOUCHCAST_SHARE_TAB_MENUS: 'tcTabs',
        //css class for embed sizes
        CSS_TOUCHCAST_EMBED_SIZES: 'embedSizes',
        //css class for embed values list
        CSS_TOUCHCAST_EMBED_VALUES: 'embedSizeValues',
        //css class for embed link
        CSS_TOUCHCAST_EMBED_LINK: 'tcShareEmbedLink',
        //css class for share link
        CSS_TOUCHCAST_SHARE_LINK: 'tcShareLink',
        //css class for selected embed size value
        CSS_TOUCHCAST_SELECTED_EMBED_SIZE: 'tcSelected',
        //css class for selected embed size label
        CSS_TOUCHCAST_SELECTED_EMBED_SIZE_LABEL: 'tcSelectedSizeVal',
        //css class for video embed sizes wrapper
        CSS_TOUCHCAST_EMBED_SIZES_WRAPPER: 'tcShareEmbedSizeSelect',
        //css class for normal video embed sizes
        CSS_TOUCHCAST_NORMAL_EMBED_SIZES: 'tcShareEmbedSizeNormalVideos',
        //css class for square video embed sizes
        CSS_TOUCHCAST_SQUARE_EMBED_SIZES: 'tcShareEmbedSizeSquareVideos',
        //css class for embed size list item
        CSS_TOUCHCAST_EMBED_SIZE_ITEM: 'tcEmbedSizeList',
        //css class for selected embed size tick
        CSS_TOUCHCAST_EMBED_SIZE_TICK: 'tcTickMark',
        //css class for share icons wrapper
        CSS_TOUCHCAST_SHARE_ICONS_WRAPPER: 'tcShareIcons',
        //css class for share FB icon
        CSS_TOUCHCAST_SHARE_FB_ICON: 'tcShareIconsFB',
        //css class for share twitter icon
        CSS_TOUCHCAST_SHARE_TWITTER_ICON: 'tcShareIconsTwitter',
        //css class for mute
        CSS_TOUCHCAST_MUTE: 'mute',
        //css class for video list container
        CSS_TOUCHCAST_VIDEO_LIST_CONTAINER: 'tcProgressBarVideoListContainer',
        //css class for video list item
        CSS_TOUCHCAST_VIDEO_LIST_ITEM: 'tcVideoList',
        //css class for default background transition
        CSS_TOUCHCAST_BG_TRANSITION: 'tcBgTransition',
        //css class for vapp container
        CSS_TOUCHCAST_VAPP_CONTAINER: 'touchcast_vapp_container',
        //css class for vapp icons
        CSS_TOUCHCAST_VAPP_ICONS: 'tcVappIcons',
        // css class for vapp preview img wrapper
        CSS_TOUCHCAST_VAPP_PREVIEW_WRAPPER: 'vappImgWrapper',
        //css class for vapp preview img container
        CSS_TOUCHCAST_VAPP_PREVIEW_CONTAINER: 'vappPreviewCircleBorderColor',
        //css class for vapp icon
        CSS_TOUCHCAST_VAPP_ICON: 'tcVappIconsMouseOverArea',
        //css id for end share button
        CSS_TOUCHCAST_END_SHARE_BUTTON: 'tcEndShare',
        // css id for end download button
        CSS_TOUCHCAST_END_DOWNLOAD_BUTTON: 'tcEndDownload',
        // css id for end replay button
        CSS_TOUCHCAST_END_REPLAY_BUTTON: 'tcEndReplay',
        //css class for zclip container
        CSS_TOUCHCAST_ZCLIP: 'zclip',
        //css class for video title
        CSS_TOUCHCAST_VIDEO_TITLE: 'tcVideoTitle',
        //css class for video channel name
        CSS_TOUCHCAST_VIDEO_CHANNEL: 'tcVideoChannel',
        //css class for video description
        CSS_TOUCHCAST_VIDEO_DESC: 'info-desc',
        //css class for no video description
        CSS_TOUCHCAST_NO_VIDEO_DESC: 'noInfoDesc',
        //css class for avatar container
        CSS_TOUCHCAST_AVATAR_CONTAINER: 'avatar-info',
        //css class for avatar
        CSS_TOUCHCAST_AVATAR: 'avatar',
        //css class for video views
        CSS_TOUCHCAST_VIDEO_VIEWS: 'tcVideoViews',
        //css class for video shares
        CSS_TOUCHCAST_VIDEO_SHARES: 'tcVideoShares',
        //css class for video recasts
        CSS_TOUCHCAST_VIDEO_RECASTS: 'tcVideoReCasts',
        //css class for modal box
        CSS_TOUCHCAST_MODAL_BOX: 'tc-modal-box',
        //css class for close modal
        CSS_TOUCHCAST_MODAL_CLOSE: 'close-modal',
        //css class for flag button
        CSS_TOUCHCAST_FLAG_BUTTON: 'flag',
        //css class for unflag button
        CSS_TOUCHCAST_UNFLAG_BUTTON: 'unflag',
        //css class for flag modal
        CSS_TOUCHCAST_FLAG_MODAL: 'flaggingPopupContainer',
        //css class for submit flag
        CSS_TOUCHCAST_SUBMIT_FLAG_BUTTON: 'flag-flagging',
        //css id for flag reason
        CSS_TOUCHCAST_FLAG_REASON: 'reason',
        //css class for flag success message
        CSS_TOUCHCAST_FLAG_MESSAGE: 'success-msg',
        //css class for bookmark button
        CSS_TOUCHCAST_BOOKMARK_BUTTON: 'tcInfoBookmark',
        //css class for bookmarked
        CSS_TOUCHCAST_BOOKMARKED: 'bookmarked',
        //css class for follow button
        CSS_TOUCHCAST_FOLLOW_BUTTON: 'tcInfoFollow',
        //css class for subscribed
        CSS_TOUCHCAST_SUBSCRIBED: 'subscribed',
        //css class for comments wrapper
        CSS_TOUCHCAST_COMMENTS_WRAPPER: 'tcVideoPostCommentWrapper',
        //css class for comments container
        CSS_TOUCHCAST_COMMENTS_CONTAINER: 'tcVideoPostCommentArea',
        //css class for loading
        CSS_TOUCHCAST_LOADING: 'loading',
        //css class for comment items wrapper
        CSS_TOUCHCAST_COMMENT_ITEMS: 'tcVPComments',
        //css class for comment divider
        CSS_TOUCHCAST_COMMENT_DIVIDER: 'tcVideoCommentDivider',
        //css class for comment item wrapper
        CSS_TOUCHCAST_COMMENT_ITEM: 'tcVideoComments',
        //css class for comment avatar
        CSS_TOUCHCAST_COMMENT_AVATAR: 'tcVideoCommentAvatar',
        //css class for comment content
        CSS_TOUCHCAST_COMMENT_CONTENT: 'tcVideoComment',
        //css class for comment username
        CSS_TOUCHCAST_COMMENT_USERNAME: 'tcVideoCommentUserName',
        //css class for comment text
        CSS_TOUCHCAST_COMMENT_TEXT: 'tcVideoUserComment',
        //css class for comment time
        CSS_TOUCHCAST_COMMENT_TIME: 'tcVideoCommentTime',
        //css class for no comments
        CSS_TOUCHCAST_NO_COMMENTS: 'noComments',
        //css id for recast language change element
        CSS_TOUCHCAST_PLAYER_LANGUAGE_RECAST_TOOLTIP: 'tcLangReCast',
        //css class for remove recast language change element
        CSS_TOUCHCAST_PLAYER_LANGUAGE_RECASTED_TOOLTIP: 'tcVideoReCasted',
        //css id for recast popup content recast button language changes
        CSS_TOUCHCAST_PLAYER_LANGUAGE_RECAST_POPUP_RECAST_BUTTON: 'reCastThisTC',
        //css id for recast popup content recast description language changes
        CSS_TOUCHCAST_PLAYER_LANGUAGE_RECAST_POPUP_RECAST_DESCRIPTION: 'tcLangReCastDesc',
        //css id for remove recast popup text
        CSS_TOUCHCAST_PLAYER_LANGUAGE_REMOVE_RECAST_POPUP_CONTENT: 'removeReCast',
        //css id for share icon tooltip language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_TOOLTIP: 'tcLangShare',
        //css id for share tab text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_TAB_TEXT: 'tcLangShareTab',
        //css id for share embed tab text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_EMBED_TAB_TEXT: 'tcLangEmbedTab',
        //css id for share sharetab copy text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_TAB_COPY_TEXT: 'shareLinkCopyLink',
        //css id for share embedtab copy text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_EMBED_TAB_COPY_TEXT: 'tcShareEmbedLinkCopyLink',
        //css id for share panel fb icon title and tooltip
        CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_PANEL_FB_TOOLTIP: 'tcLangShareIconsFB',
        //css id for share panel twitter icon titile and tooltip
        CSS_TOUCHCAST_PLAYER_LANGUAGE_SHARE_PANEL_TWITTER_TOOLTIP: 'tcLangShareIconsTwitter',
        //css id for info panel flag text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_FLAG_TEXT: 'tcLangFlagText',
        //css id for info panel bookmark tooltip text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_BOOKMARK_TOOLTIP: 'tcLangBookmarkTooltip',
        //css id for info panel bookmark text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_BOOKMARK_TEXT: 'tcLangInfoBookmark',
        //css id for info panel flag text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_FOLLOW_TOOLTIP: 'tcLangFollowTooltip',
        //css id for info panel flag text for language change
        CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_FOLLOW_TEXT: 'tcLangFollowTooltip',
        //css class for settings panel
        CSS_TOUCHCAST_SETTINGS_PANEL: 'settings',
        //css class for settings icon
        CSS_TOUCHCAST_CONTROL_BUTTON_SETTINGS: 'tcVideoSettingsIcon',
        //css class for settings values
        CSS_TOUCHCAST_SETTINGS_VALUES: 'settingsValues',
        //css class for settings panel
        CSS_TOUCHCAST_SUBTITLES_PANEL: 'subtitles',
        //css class for show settings popup arrow
        CSS_TOUCHCAST_SETTINGS_SHOW_POPUP_ARROW: 'showSettingsPopupArrow',
        //css for subtitles link
        CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES: 'tcSubtitle',
        //css for subtitles link
        CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_LABEL: 'labelSubtitle',
        //css for subtitles link
        CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_SELECTED_LANG: 'tcSubtitleSelectedLang',
        //css for subtitles link
        CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_TITLE: 'tcSubtitlesTitle',
        //css for subtitles link
        CSS_TOUCHCAST_TRANSCRIPT: 'transcript',
        //css class for transcriptions icon
        CSS_TOUCHCAST_CONTROL_BUTTON_TRANSCRIPTIONS: 'tcVideoTranscriptionsIcon',
        //css class for langauge list
        CSS_TOUCHCAST_LANGUAGES_LIST: 'tcLangsList',
        //css class for language selected
        CSS_TOUCHCAST_LANGUAGES_SELECTED: 'selectedLang',
        //css class for disabled
        CSS_TOUCHCAST_DISABLED: 'tcDisabled',
        //css class for disabled text
        CSS_TOUCHCAST_DISABLED_TEXT: 'tcDisabledText',
        //css id for hls canvas
        CSS_TOUCHCAST_HLS_CANVAS: 'hls-canvas',
        //css class for chat input wrapper
        CSS_TOUCHCAST_CHAT_INPUT_WRAPPER: 'tcChatInputWrapper',
        //css class for chat input
        CSS_TOUCHCAST_CHAT_INPUT: 'tcChatInput',
        //css class for chat wrapper
        CSS_TOUCHCAST_CHAT_WRAPPER: 'tcChatWrapper',
        //css class for chat box
        CSS_TOUCHCAST_CHAT_BOX: 'tcChatBox',
        //css class for chat icon
        CSS_TOUCHCAST_CHAT_ICON: 'tcVideoChatIcon',
        //css class for chat icon
        CSS_TOUCHCAST_THUMBS_ICON: 'tcThumbs',
        //css class for chat wrapper
        CSS_TOUCHCAST_THUMBS_WRAPPER: 'tcThumbsWrapper',
        //css class for live icon
        CSS_TOUCHCAST_LIVE_ICON: 'tcLive',
        //css class for live icon
        CSS_TOUCHCAST_FLYING_THUMBS_ICON: 'thumb',
        //css class for live icon
        CSS_TOUCHCAST_CHAT_BUBBLE: 'tcChatBubble',
        //css class for chat name
        CSS_TOUCHCAST_CHAT_NAME: 'tcChatName',
        //css class for chat message
        CSS_TOUCHCAST_CHAT_MESSAGE: 'tcChatMessage',
        //css class for iphone overlay
        CSS_TOUCHCAST_IPHONE_OVERLAY: 'iPhoneOverlay',
        //css class for iphone scroll up image
        CSS_TOUCHCAST_IPHONE_SCROLL_UP: 'scrollupImg',
        // css for iphone play tip
        CSS_TOUCHCAST_IPHONE_PLAY_TAP_TIP: 'tciPhonePlayTip',
        // css for sound audio tag
        CSS_TOUCHCAST_SOUND_TAG: 'tcSound',
        // css for sound audio src
        CSS_TOUCHCAST_SOUND_SRC: 'tcSoundMp3Src',
        // css for main play button bottom right
        CSS_TOUCHCAST_MAIN_PLAY_BUTTON_BOTTOM_RIGHT: 'tcMainPlayButtonBottomRight',
        //css class for search icon
        CSS_TOUCHCAST_ICON_SEARCH: 'tcSearchIcon',
        //css class for search close icon
        CSS_TOUCHCAST_ICON_SEARCH_CLOSE: 'tcSearchCloseIcon',
        //css class for search wrapper
        CSS_TOUCHCAST_WRAPPER_SEARCH: 'tcSearchWrapper',
        //css class for search overlay
        CSS_TOUCHCAST_OVERLAY_SEARCH: 'overlaySearch',
        //css id for search frame
        CSS_TOUCHCAST_ID_FRAME_SEARCH: 'search-frame',
        //css class for video blur
        CSS_TOUCHCAST_VIDEO_BLUR: 'tcVideoBlur',
        // css chat container
        CSS_TOUCHCAST_USER_CHAT: 'tcUserChat',
        // css new chat animation
        CSS_TOUCHCAST_NEW_CHAT_MESSAGE: 'tcChatNewMessage',
        // css form comment post
        CSS_TOUCHCAST_COMMENT_FORM: 'frmVideoComment',
        // css context menu item copy debug
        CSS_TOUCHCAST_CONTEXT_MENU_ITEM_COPY_DEBUG: 'tcContextMenuLinkCopyDebug',
        // css context menu item copy embed
        CSS_TOUCHCAST_CONTEXT_MENU_ITEM_COPY_EMBED: 'tcContextMenuLinkCopyEmbed',
        // css context menu item show debug
        CSS_TOUCHCAST_CONTEXT_MENU_ITEM_SHOW_DEBUG: 'tcContextMenuLinkShowDebug',
        // css context menu active
        CSS_TOUCHCAST_CONTEXT_MENU_ACTIVE: 'tcContextMenuActive',
        // css context menu
        CSS_TOUCHCAST_CONTEXT_MENU: 'tcContextMenu',
        // css context menu item
        CSS_TOUCHCAST_CONTEXT_MENU_ITEM: 'tcContextMenuItem',
        // css context menu item link
        CSS_TOUCHCAST_CONTEXT_MENU_ITEM_LINK: 'tcContextMenuLink',
        // css stats container
        CSS_TOUCHCAST_STATS_CONTAINER: 'tcStatsContainer',
        // css stats main container
        CSS_TOUCHCAST_STATS_MAIN_CONTAINER: 'tcStatsMainContainer',
        // css stats container
        CSS_TOUCHCAST_STATS_CONTAINER_CLOSE: 'tcStatsContainerButton',
        // css class for error container
        CSS_TOUCHCAST_ERROR_CONTAINER: 'tcErrorContainer',
        // Error text
        CSS_TOUCHCAST_ERROR_TEXT: 'Oops! Something went wrong and we can\'t play the touchcast at this moment. Please try again later!',
        // css class for error container
        CSS_TOUCHCAST_NOTIFICATION_CONTAINER: 'notificationContainer',
        // css id for video wrapper
        CSS_TOUCHCAST_VIDEO_WRAPPER: 'tc-video-wrapper',
        // css class for video height aligned
        CSS_TOUCHCAST_VIDEO_HEIGHT_ALIGNER: 'tc-height-aligner',
        // css class for video wrapper if livestream
        CSS_TOUCHCAST_VIDEO_WRAPPER_LIVESTREAM: 'tc-livestream'

    };
});

